import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import styles from "../sidequest.module.scss";
import mainlogo from "../../../assets/images/new_web_logo.png";

const Topbar = () => {
  return (
    <header className={styles.topbar}>
      <Link to="/">
        <img src={mainlogo} alt="KeyQuest" />
      </Link>
      <Link to="/" className={styles.topbarBack}>
        <ArrowLeft size={16} />
        <span>Back to Home</span>
      </Link>
    </header>
  );
};

export default Topbar;
